<template>
    <v-snackbar v-model="open" :top=true>
        {{snackbarContent}}
        <v-btn
                dark
                icon
                @click="open = false"
        >
            <v-icon>mdi-close</v-icon>
        </v-btn>
    </v-snackbar>
</template>

<script>
    export default {
        name: "Snackbar",
        data: () => ({
            open: false,
            snackbarContent: ''
        }),
        methods: {
            info(mes) {
                this.snackbarContent = mes;
                this.open = true;
            },
            error(mes) {
                this.snackbarContent = mes;
                this.open = true;
            },
            warning(mes) {
                this.snackbarContent = mes;
                this.open = true;
            },
            success(mes) {
                this.snackbarContent = mes;
                this.open = true;
            }
        }
    }
</script>

<style scoped>

</style>